module.exports = __webpack_public_path__ + "static/media/prince_of_persia_castle.c7689cad.png";